export default "__VITE_ASSET__ee76ac7f__"